import React, { Fragment } from 'react';
import { Intro, PagerButton, Voiceover } from 'dea-core';
import image from '../../assets/images/U1-T1-07.svg';
import voAudio from '../../assets/vo/Opioid-M-One-08.mp3';

const vo = {
  sources: [
    {
      src: voAudio
    }
  ],
  transcript:
    'Now we will take a dive into prescription opioids, heroin, and illicit fentanyl in order to better understand the nuances of this epidemic.'
};

export default {
  title: 'A Deeper Dive',
  path: '/elaborate/a-deeper-dive',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        img={image}
        title="A Deeper Dive"
        lead="Let’s explore each of the three major contributors in more detail."
      />
      <PagerButton />
    </Fragment>
  )
};



// WEBPACK FOOTER //
// ./src/data/elaborate/ADeeperDive.js